// TODO: new scenario trigger constant
export const scenarioTriggers = {
  allAlarmTypes: "allAlarmTypes",
  genericAlarm: "genericAlarm",
  lowPrioAlarm: "lowPrioAlarm",
  sosButton: "sosButton",
  manDown: "manDown",
  ripcord: "ripcord",
  timer: "timer",
  configError: "configError",
  alarmClosed: "alarmClosed",
  assistanceRequestClosed: "assistanceRequestClosed",
  connectionChanged: "connectionChanged",
  quickButton: "quickButton",
  beaconBattery: "beaconBattery",
  geofenceAttendance: "geofenceAttendance",
  geofenceEntered: "geofenceEntered",
  geofenceExited: "geofenceExited",
  teamAttendance: "teamAttendance",
  idle: "idle",
  docked: "docked",
  undocked: "undocked",
  lowBattery: "lowBattery",
  noAlarmTriggered: "noAlarmTriggered",
  smsMessage: "smsMessage",
  webhook: "webhook",
  ioChange: "ioChange",
  email: "email",
  espa: "espa",
  multiTenant: "multiTenant",
  messageNotAcknowledged: "messageNotAcknowledged",
  checkAssistanceRequestResponses: "checkAssistanceRequestResponses",
  arcAlarm: "arcAlarm",
  scenarioDisabled: "scenarioDisabled",
};
